import React from 'react'
import { HightLight, Text } from '../gameRulesStyle'
import ChartComponent from './elements/ChartComponent'

export default function Chart() {
  return (
    <>
      <HightLight fontSize='22px' background='red' margin={'30px 0 15px'}>
        Chart
      </HightLight>
      <Text>
        SHOWS LIVE GAME STATS WITH Y-AXIS DEPENDING
        <HightLight fontSize='18px' background='red'>
          {' '}
          ROLL UNDER
        </HightLight>{' '}
        /
        <HightLight fontSize='18px' background='blue'>
          {' '}
          ROLL Over
        </HightLight>{' '}
        VALUE AND X-AXIS OF YOUR LIVE GAME RESULTS
      </Text>
      <ChartComponent />
    </>
  )
}
